<div class="pager-position">
  <mat-form-field class="pager-page">
    <mat-label>{{'front.pager.page' | translate}}</mat-label>
    <mat-select [(ngModel)]="pageValue" (ngModelChange)="updatePage()" panelClass="pager-option-size">
      @for (page of pageList; track page) {
        <mat-option [value]="page">{{page}}/{{pageList.length}}</mat-option>
      }
    </mat-select>
    <mat-hint class="w-100 text-right">Total : </mat-hint>
  </mat-form-field>
  <div class="pager-interval d-inline-block"></div>
  <mat-form-field class="pager-page">
    <mat-label>{{'front.pager.nbElementParPage' | translate}}</mat-label>
    <mat-select [(ngModel)]="resultsValue" (ngModelChange)="updateResults();updatePage()" panelClass="pager-option-size">
      @for (result of resultList; track result) {
        <mat-option [value]="result">{{result}}</mat-option>
      }
    </mat-select>
    <mat-hint>{{totalItems}}</mat-hint>
  </mat-form-field>
  <div class="w-25 d-inline-block"></div>
</div>
